export const AUTH_ENDPOINTS = {
  LOGIN: "/v1/admin/login",
  VERIFY_MFA: "/v1/admin/mfa-verify",
  VERIFY_MFA_BACKUP_CODE: "/v1/admin/mfa-verify",
  SETUP_ACCOUNT: "/v1/admin/create/complete",
  GET_2FA_SECRET: "/v1/admin/mfa-setup",
}